<template>
   <div class="paper" style="left: 0;width: 100%;">
      <div class="header" style="background: #fff; padding: 10px 20px;" >
         <div class="home-bar">
            <a  v-on:click="dash()" ><i class='bx bxs-home'></i><img :src="publicOrganizationData.logoColor[0].url"  alt=""  style="width:150px; overflow:hidden; height: 47px; display: block; float: right;"> </a>
         </div>
         <div class="control-bar row"> 
            <div class="profile">
               <a class="" data-toggle="dropdown"> 
                  <i class="bx bx-user"></i>
               </a>
               <div class="dropdown-menu">
                  <a class="dropdown-item" href="#"><strong>{{ user.replace(organizationID.replace('ORG#','').toLowerCase()+'.','') }}</strong> </a>
                  <a class="dropdown-item" href="#">- <strong v-for="(item, index) in userPermissions" :key="index">{{ item }}</strong> - </a>
                  <a class="dropdown-item" :href="'/register?smlName=forgotPasswordpm&smlPK=org'" >Change Password</a>
                  <a class="dropdown-item" href="#" v-on:click="logOut();">Log Out</a>
               </div>
            </div>
         </div>
      </div>
      <div class="smart-wrap dash" v-if=" organizationData.app == 'CLE'" >
         <div class="col-md-12" style="padding: 20px 0;">
            <h1>{{ data.CON.attributes['contact.firstName'].attributeValue+' '+ data.CON.attributes['contact.lastName'].attributeValue}}</h1>
            <p >Phone: {{ data.PHO.attributes['phoneNumber'].attributeValue }}</p>
            <p >Email: {{ data.EML.attributes['contact.email'].attributeValue }}</p>
            <p>Address: {{ data.CON.attributes['contact.streetAddress'].attributeValue+' '+data.CON.attributes['contact.city'].attributeValue+' '+data.CON.attributes['contact.state'].attributeValue+', '+data.CON.attributes['contact.zipCode'].attributeValue }}</p>
         </div>
         <div class="col-md-8">
            <div class="smart-wrap col-12" v-for="(list, index) in data.Tables" :key="index">
               <h4 style="width: 100%;">{{list.Title}}</h4>
               <div class="list-group"   style="width: 100%;" >
                  <div href="#" class="list-group-item list-group-item-action " v-for="(record, rIndex) in list.data" :key="rIndex" v-on:click="setgRecord([record, 'out']);" >
                     <div data-toggle="modal" data-target="#modal-customer"  style="justify-content: space-between;    flex-wrap: wrap;">
                        <span v-if="record.subscribe">
                           <i v-if="record.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                           <i v-if="record.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
                        </span>
                        <div class="col-md-12 " style="display: flex;align-items: center;justify-content: space-between;background: #e1e1e1;padding: 10px 20px;"> 
                           <span > <strong>Worker: </strong> {{ record.attributes['responsible'].attributeValue.value }} </span>
                           <img style="width: 50px; border-radius: 100px;" :src="record.attributes['responsible'].picture" alt="">
                        </div>
                        <p class="col-md-12 col-text" > 
                           <strong>{{ record.attributes['orderNumber'].label }}: </strong> 
                           <span > {{ record.attributes['orderNumber'].attributeValue }} </span>
                           <span > ( {{ formatData('date',record.attributes['date'].attributeValue)[0]}}  )</span>
                        </p>
                        <p class="col-md-12 col-text" > 
                           <strong>{{ record.attributes['provider'].label }}: </strong> 
                           <span > {{ record.attributes['provider'].attributeValue.value }} </span>
                        </p>
                        <p class="col-md-12 col-text" > 
                           <strong>Address: </strong> 
                           <span >&nbsp;{{ record.attributes['contact.streetAddress'].attributeValue }}</span>
                           <span >&nbsp;{{ record.attributes['contact.city'].attributeValue }}</span>
                           <span >&nbsp;{{ record.attributes['contact.state'].attributeValue }}</span>
                           <span >&nbsp;{{ record.attributes['contact.zipCode'].attributeValue }}</span>
                        </p>
                        <p class="col-md-12 col-text" > 
                           <strong>{{ record.attributes['status'].label }}: </strong> 
                           <span > {{ record.attributes['status'].attributeValue }} </span>
                        </p>
                        <div class="col-md-12">
                           <img :src="img.url" style="width: 25%;" alt="" v-for="(img, index) in record.attributes['pictures'].attributeValue" :key="index">
                        </div>
                     </div>
                     <div class="collapse " :id="'collapse-'+rIndex" >
                        <div class="input-wrap" v-for="(input, x) in 5" :key="x">
                           <label for="">Label</label>
                           <input type="text" placeholder="attributeValue">
                        </div>
                        <a href="" class="btn-g show blue" style="width: 200px;  display: block; padding: 10px 0; margin: 20px auto;">
                           Save
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-md-4">
            <h2>Payment Form</h2>
            <div class="list-group" style="padding: 50px 0;" v-if="data.CON.attributes['paymentMethods']">
               <a href="#" class="list-group-item list-group-item-action"   v-for="(item, index) in data.CON.attributes['paymentMethods'].attributeValue" :key="index">
                  <p data-toggle="collapse" :href="'#collapse-'+index" role="button" aria-expanded="false" aria-controls="collapseExample" class="absoluteCenterFlex" style="justify-content: space-between;">
                     <div  class="absoluteCenterFlex">
                     **** **** **** {{ item.last4Digits }}
                     &nbsp;  
                     <svg v-if="item.type=='Visa'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="currentColor" d="M23.26 11.495a6.734 6.734 0 0 0-2.323-.401c-2.557 0-4.364 1.292-4.375 3.141c-.021 1.359 1.281 2.125 2.265 2.583c1.011.469 1.349.761 1.344 1.177c-.005.641-.808.927-1.547.927c-1.027 0-1.584-.14-2.443-.5l-.319-.151l-.364 2.136c.625.255 1.745.479 2.901.5c2.724 0 4.5-1.281 4.52-3.256c.021-1.083-.676-1.905-2.161-2.583c-.896-.437-1.457-.735-1.457-1.183c0-.396.479-.812 1.479-.812a4.763 4.763 0 0 1 1.937.359l.245.109l.359-2.057zm6.647-.224h-2c-.625 0-1.089.167-1.365.787l-3.844 8.713h2.719l.548-1.427l3.317.005c.083.333.317 1.421.317 1.421H32zm-17.027-.078h2.589l-1.62 9.504H11.26l1.62-9.509zm-6.583 5.234l.265 1.323l2.536-6.479h2.745l-4.084 9.484H5.026l-2.24-8.031a.507.507 0 0 0-.245-.317A10.935 10.935 0 0 0 0 11.464l.031-.199h4.177c.563.021 1.021.199 1.177.803l.912 4.364zm20.406.974l1.037-2.661c-.016.025.213-.547.343-.907l.177.817l.6 2.745h-2.157z"/></svg>
                     <svg v-if="item.type=='Mastercard'" width="32" height="32" viewBox="0 0 2000 1556" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2942_2)">
                           <path
                              d="M1960.59 1534.9V1538.9H1964.32C1965.02 1538.91 1965.71 1538.74 1966.32 1538.39C1966.56 1538.22 1966.76 1537.99 1966.89 1537.72C1967.02 1537.45 1967.08 1537.16 1967.07 1536.86C1967.08 1536.57 1967.02 1536.28 1966.89 1536.02C1966.76 1535.76 1966.56 1535.53 1966.32 1535.37C1965.72 1535.01 1965.02 1534.83 1964.32 1534.86H1960.59V1534.9ZM1964.36 1532.07C1965.96 1531.97 1967.54 1532.43 1968.84 1533.37C1969.36 1533.8 1969.77 1534.34 1970.05 1534.95C1970.32 1535.57 1970.44 1536.24 1970.41 1536.91C1970.43 1537.49 1970.33 1538.06 1970.12 1538.6C1969.9 1539.14 1969.57 1539.62 1969.15 1540.02C1968.15 1540.89 1966.89 1541.41 1965.57 1541.51L1970.57 1547.21H1966.72L1962.12 1541.55H1960.63V1547.21H1957.41V1532.08H1964.41L1964.36 1532.07ZM1963.36 1552.43C1965.05 1552.45 1966.72 1552.11 1968.27 1551.43C1969.76 1550.79 1971.12 1549.87 1972.27 1548.72C1973.42 1547.57 1974.34 1546.22 1974.98 1544.72C1976.29 1541.55 1976.29 1537.99 1974.98 1534.82C1974.33 1533.33 1973.41 1531.97 1972.27 1530.82C1971.12 1529.67 1969.76 1528.75 1968.27 1528.11C1966.71 1527.47 1965.04 1527.15 1963.36 1527.17C1961.65 1527.15 1959.95 1527.47 1958.36 1528.11C1956.83 1528.74 1955.45 1529.66 1954.27 1530.82C1952.5 1532.63 1951.3 1534.93 1950.83 1537.42C1950.36 1539.91 1950.62 1542.48 1951.6 1544.82C1952.21 1546.32 1953.12 1547.68 1954.27 1548.82C1955.45 1549.98 1956.83 1550.9 1958.36 1551.53C1959.94 1552.2 1961.64 1552.55 1963.36 1552.53M1963.36 1523.53C1967.76 1523.53 1971.98 1525.25 1975.11 1528.33C1976.62 1529.81 1977.82 1531.57 1978.65 1533.52C1979.5 1535.52 1979.95 1537.67 1979.95 1539.84C1979.95 1542.02 1979.5 1544.17 1978.65 1546.17C1977.81 1548.11 1976.6 1549.87 1975.11 1551.36C1973.58 1552.83 1971.79 1554.02 1969.84 1554.86C1967.79 1555.73 1965.59 1556.17 1963.36 1556.16C1961.11 1556.18 1958.88 1555.73 1956.8 1554.86C1954.83 1554.04 1953.03 1552.85 1951.49 1551.36C1950 1549.81 1948.81 1547.99 1948 1546C1947.15 1544 1946.7 1541.85 1946.7 1539.68C1946.7 1537.5 1947.15 1535.35 1948 1533.35C1948.83 1531.4 1950.03 1529.64 1951.54 1528.16C1953.05 1526.65 1954.86 1525.45 1956.85 1524.66C1958.93 1523.79 1961.16 1523.34 1963.41 1523.36M432.16 1465.1C432.16 1436.25 451.06 1412.55 481.95 1412.55C511.47 1412.55 531.39 1435.23 531.39 1465.1C531.39 1494.97 511.47 1517.65 481.95 1517.65C451.06 1517.65 432.16 1493.95 432.16 1465.1ZM565.04 1465.1V1383H529.35V1403C518.03 1388.22 500.86 1378.95 477.51 1378.95C431.51 1378.95 395.41 1415.03 395.41 1465.14C395.41 1515.25 431.49 1551.33 477.51 1551.33C500.85 1551.33 518.03 1542.05 529.35 1527.28V1547.21H565V1465.1H565.04ZM1770.96 1465.1C1770.96 1436.25 1789.86 1412.55 1820.76 1412.55C1850.31 1412.55 1870.2 1435.23 1870.2 1465.1C1870.2 1494.97 1850.31 1517.65 1820.76 1517.65C1789.87 1517.65 1770.96 1493.95 1770.96 1465.1ZM1903.88 1465.1V1317.1H1868.16V1403C1856.84 1388.22 1839.67 1378.95 1816.32 1378.95C1770.32 1378.95 1734.22 1415.03 1734.22 1465.14C1734.22 1515.25 1770.3 1551.33 1816.32 1551.33C1839.67 1551.33 1856.84 1542.05 1868.16 1527.28V1547.21H1903.88V1465.1ZM1008 1410.86C1031 1410.86 1045.77 1425.28 1049.54 1450.67H964.38C968.19 1426.97 982.58 1410.86 1008.01 1410.86M1008.72 1378.86C960.62 1378.86 926.97 1413.86 926.97 1465.05C926.97 1517.24 961.97 1551.24 1011.11 1551.24C1035.83 1551.24 1058.47 1545.07 1078.39 1528.24L1060.9 1501.79C1047.14 1512.79 1029.62 1518.96 1013.15 1518.96C990.15 1518.96 969.21 1508.31 964.06 1478.76H1085.93C1086.28 1474.32 1086.64 1469.84 1086.64 1465.04C1086.28 1413.87 1054.64 1378.85 1008.7 1378.85M1439.6 1465.04C1439.6 1436.19 1458.5 1412.49 1489.39 1412.49C1518.91 1412.49 1538.83 1435.17 1538.83 1465.04C1538.83 1494.91 1518.91 1517.59 1489.39 1517.59C1458.5 1517.59 1439.59 1493.89 1439.59 1465.04M1572.47 1465.04V1383H1536.8V1403C1525.44 1388.22 1508.31 1378.95 1484.96 1378.95C1438.96 1378.95 1402.86 1415.03 1402.86 1465.14C1402.86 1515.25 1438.94 1551.33 1484.96 1551.33C1508.31 1551.33 1525.44 1542.05 1536.8 1527.28V1547.21H1572.48V1465.1L1572.47 1465.04ZM1238.05 1465.04C1238.05 1514.83 1272.71 1551.23 1325.61 1551.23C1350.33 1551.23 1366.8 1545.73 1384.61 1531.66L1367.47 1502.81C1354.07 1512.44 1340 1517.59 1324.47 1517.59C1295.98 1517.24 1275.03 1496.64 1275.03 1465.04C1275.03 1433.44 1295.98 1412.85 1324.47 1412.49C1339.96 1412.49 1354.03 1417.64 1367.47 1427.27L1384.61 1398.42C1366.77 1384.35 1350.3 1378.85 1325.61 1378.85C1272.71 1378.85 1238.05 1415.24 1238.05 1465.04ZM1698.15 1378.85C1677.56 1378.85 1664.15 1388.48 1654.88 1402.9V1383H1619.51V1547.12H1655.24V1455.12C1655.24 1427.96 1666.91 1412.87 1690.24 1412.87C1697.88 1412.76 1705.47 1414.16 1712.56 1417L1723.56 1383.36C1715.66 1380.25 1705.36 1378.88 1698.13 1378.88M741.49 1396.05C724.32 1384.73 700.66 1378.88 674.56 1378.88C632.98 1378.88 606.21 1398.81 606.21 1431.42C606.21 1458.18 626.14 1474.69 662.84 1479.84L679.7 1482.24C699.27 1484.99 708.51 1490.14 708.51 1499.41C708.51 1512.1 695.51 1519.34 671.1 1519.34C646.38 1519.34 628.54 1511.44 616.51 1502.17L599.74 1530C619.31 1544.42 644.03 1551.3 670.8 1551.3C718.2 1551.3 745.67 1528.98 745.67 1497.73C745.67 1468.88 724.05 1453.79 688.33 1448.64L671.51 1446.2C656.06 1444.2 643.68 1441.09 643.68 1430.09C643.68 1418.09 655.35 1410.87 674.93 1410.87C695.88 1410.87 716.16 1418.77 726.1 1424.94L741.55 1396.09L741.49 1396.05ZM1202 1378.91C1181.41 1378.91 1168 1388.54 1158.77 1402.96V1383H1123.4V1547.12H1159.09V1455.12C1159.09 1427.96 1170.76 1412.87 1194.09 1412.87C1201.73 1412.76 1209.32 1414.16 1216.41 1417L1227.41 1383.36C1219.51 1380.25 1209.21 1378.88 1201.98 1378.88M897.44 1383H839.08V1333.21H803V1383H769.71V1415.62H803V1490.49C803 1528.57 817.78 1551.25 860 1551.25C875.49 1551.25 893.33 1546.45 904.65 1538.56L894.34 1508C883.69 1514.17 872.02 1517.28 862.74 1517.28C844.9 1517.28 839.08 1506.28 839.08 1489.81V1415.65H897.44V1383ZM363.85 1547.16V1444.16C363.85 1405.37 339.13 1379.27 299.28 1378.92C278.33 1378.57 256.72 1385.09 241.59 1408.12C230.27 1389.92 212.43 1378.92 187.35 1378.92C169.82 1378.92 152.69 1384.07 139.28 1403.29V1383H103.56V1547.12H139.56V1456.12C139.56 1427.63 155.36 1412.49 179.76 1412.49C203.46 1412.49 215.45 1427.94 215.45 1455.76V1547.1H251.53V1456.1C251.53 1427.61 268 1412.47 291.69 1412.47C316.06 1412.47 327.69 1427.92 327.69 1455.74V1547.08L363.85 1547.16Z"
                              fill="#231F20" />
                           <path
                              d="M1980.94 1001.22V977.22H1974.69L1967.46 993.69L1960.27 977.22H1954V1001.22H1958.44V983.14L1965.2 998.74H1969.8L1976.56 983.1V1001.22H1980.96H1980.94ZM1941.29 1001.22V981.33H1949.29V977.28H1928.85V981.33H1936.85V1001.22H1941.25H1941.29Z"
                              fill="#2E2E2E" />
                           <path d="M1270.57 1104.15H729.71V132.15H1270.58L1270.57 1104.15Z" fill="#454545" />
                           <path
                              d="M764 618.17C764 421 856.32 245.36 1000.08 132.17C891.261 46.3646 756.669 -0.204819 618.09 -6.00748e-05C276.72 -6.00748e-05 0 276.76 0 618.17C0 959.58 276.72 1236.34 618.09 1236.34C756.672 1236.55 891.268 1189.98 1000.09 1104.17C856.34 991 764 815.35 764 618.17Z"
                              fill="#231F20" />
                           <path
                              d="M2000.25 618.17C2000.25 959.58 1723.53 1236.34 1382.16 1236.34C1243.56 1236.54 1108.95 1189.97 1000.11 1104.17C1143.91 990.98 1236.23 815.35 1236.23 618.17C1236.23 420.99 1143.91 245.36 1000.11 132.17C1108.95 46.3673 1243.56 -0.201108 1382.15 3.85437e-05C1723.52 3.85437e-05 2000.24 276.76 2000.24 618.17"
                              fill="#626262" />
                        </g>
                        <defs>
                           <clipPath id="clip0_2942_2">
                              <rect width="2000" height="1556" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>   
                     </div>
                  </p>
                  <div class="collapse" :id="'collapse-'+index">
                     data
                  </div>
               </a>
               <a href="#" class="list-group-item list-group-item-action" style="" >
                  <p style="font-weight: 700;" data-toggle="collapse" :href="'#collapse-addCard'" role="button" aria-expanded="false" aria-controls="collapseExample" >
                     ADD CARD
                  </p>
                  <div class="collapse" :id="'collapse-addCard'">
                     <p style="margin: 10px 0;">Enter credit card information for future payments</p>
                     <div class="demo-frame ">
                     <form action="/" method="post"  id="cardForm" autocomplete="off">
                        <label class="hosted-fields--label" for="card-number">Card Number</label>
                        <div id="card-number" class="hosted-field"></div>
               
                        <label class="hosted-fields--label" for="expiration-date">Expiration Date</label>
                        <div id="expiration-date" class="hosted-field"></div>
               
                        <label class="hosted-fields--label" for="cvv">CVV</label>
                        <div id="cvv" class="hosted-field"></div>
               
                        <label class="hosted-fields--label" for="postal-code">Postal Code</label>
                        <div id="postal-code" class="hosted-field"></div>
               
                        <div class="button-container">
                        <br>
                        <div class="input-wrap col-12" style="text-align: left;">
                           <input type="checkbox" class="box" v-model="saveCard"/>
                           <span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" > Save this CC for future transactions </span>
                           <br>
                           <input type="checkbox" class="box" v-model="tandc"/>
                           <span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" >I agree to the <a :href="publicOrganizationData.termsAndConditions" target="_blank">terms and conditions</a></span>
                        </div>
                        <br>
                        <input v-if="tandc == true && saveCard == true" type="submit" class="btn-g show green center" value="Save" style="cursor:pointer;" id="submit" v-on:click="action()" />
                        <input v-else  class="btn-g show gray center" style="cursor:pointer;" value="Save" disabled />
                        </div>
                     </form>
                     </div>
                  </div>
               </a>
            </div>
         </div>
      </div>
      <div class="velse">
         <h4>{{ organizationData.app }}</h4>
      </div>
      <paper-modal-custom/>
   </div>
</template>
<script>
let tokenQuote = null
   //AWS - GRAPHQL
   import { smd_getWebPage, smd_getRecordIndex, smd_getCustomerDash, smd_getRecordObj   } from "../../../graphql/queries";
   import { onNotify, smd_savePaymentFormContact  } from '../../../graphql/mutations'
   import { onUpdateSmartRecord, onCloneItem, onSetItemState,onUpdateAttributes } from '../../../graphql/subscriptions'
   //Tools
   import Vuex from "vuex";
   import { Auth, API,Storage } from "aws-amplify";
   import "amazon-connect-streams";
   import draggable from "vuedraggable";
   import Swal from 'sweetalert2'
   import { loading, popUp, formatData  } from "../../../store/tools";

   //Components
   import PaperDisplayer from "../../../components/papers/PaperDisplayer.vue";
   import PaperLayout from "../../../components/papers/PaperLayout.vue";
   import PaperUser from "../../../components/papers/PaperUser.vue";
   import PaperModalCustom from "../../../components/papers/PaperModalCustom.vue";
   
   import UiTable from "../../../components/ui/UiTable.vue";

   export default {
      components: {
         PaperDisplayer,
         PaperLayout,
         UiTable,
         PaperUser,
         PaperModalCustom,
      },
      data() {
         return {
            //Record
            list:[],
            data: undefined,
            sml:'',
            hostUrl:'',
            webSite: undefined,
            renderWeb: false,
            widthDisplayWebSite:'100%',
            //
            tandc: false,
            saveCard: false,
            
            methodPayment:'',
         };
      },
      created() {
         this.hostUrl = location.origin
         loading('show', 'webPreview')
         this.setUrlHistory('client')
         if ( this.organizationID == 'Not authorized') {
            this.$router.push({
               path: "/login",
            });
         } else {
            if (this.$router.currentRoute.value.query.data) {
               
            }else{
               this.getLayout()
               this.subscribe()
               setTimeout(() => {
                  this.setPaymentMethods()
               }, 1000);
            }
         }
      },
      methods: {
         ...Vuex.mapMutations([
            'setWebSite',
            'SetOrganizationID',
            'SetOrganizationData',
            'setPublicOrganization',
            'setPublicOrganizationData',
            'setgRecord',
            "setUrlHistory"
         ]),
         ...Vuex.mapActions([
            'getPublicOrganization'
         ]),
         formatData(format, data){
            return formatData(format, data)
         },
         //Init
         async setUserWeb(){
            Auth.signIn('smd_webuser', '383@JDU45ss#')
            .then((user) => { 
               //Clear Global Variables
               this.SetOrganizationID("Not authorized")
               this.SetOrganizationData("Not authorized")
               this.setPublicOrganization(undefined)
               this.setPublicOrganizationData(undefined)
               //console.clear()
               ///-----
               //this.getPublicOrganization()
               setTimeout(() => {
                  this.getSML()
                  //this.getLayout()
               }, 1500);
              //this.loading('hidden')
            })
            .catch((err) => console.log(err))
         },
         async getSML(){
            await this.getPublicOrganization()
            let pushData = {};
            let pullData = ''
            try {
               pushData = {
                  PK: this.publicOrganization+'##SML', 
                  SK: 'register', 
                  index: '4'
               }
               console.log('pushData Get Layout:', pushData);
               pullData = await API.graphql({
                  query: smd_getRecordIndex,
                  variables: pushData
               });
               pullData = pullData.data.smd_getRecordIndex
               pullData = JSON.parse(pullData.data)
               this.getLayout(pullData)
            } catch (error) {
               console.log(error);
            }
         },
         async getLayout(data){
            //console.clear()
            loading('show', 'webPreview')
            let pushData = {};
            let pullData = ''
            try {
               console.log(this.attUser);
               pushData = {
                  PK: this.organizationID,
                  SK: this.attUser['custom:GSP1PK1'],
               }
               console.log('pushData Get Layout:', pushData);
               pullData = await API.graphql({
                  query: smd_getCustomerDash,
                  variables: pushData
               });
               pullData = pullData.data.smd_getCustomerDash
               pullData = JSON.parse(pullData.data)
               console.log(pullData);
               this.data = pullData
               loading('hide', 'webPreview')
               return
               //Format data to display in table ( binds )
               for (let index = 0; index < this.record.length; index++) {
                  const record = this.record[index];
                  for (let i = 0; i < record.attributes.length; i++) {
                     let value = record.attributes[i].attributeValue
                     try {
                        value = JSON.parse(value)
                     } catch (error) { }
                     this.record[index][record.attributes[i].attributeName] =  value
                  }
                  delete this.record[index].attributes
               }
               
            } catch (error) {
               console.log(error);
               popUp(error, 'cach', 'err')
            }
            loading('hide', 'webPreview')
         },
         async logOut() {
            loading('show')
            //this.clear()
            try {
            await Auth.signOut();
            setTimeout(() => {
               console.log("salir");
               this.$router.push({
                  path: "/login",
               });
               loading('hide')
            }, 1000);
            } catch (error) {
            //console.log(error);
            loading('hide')
            Swal.fire({
               icon: 'error',
               title: 'Something went wrong!' ,
               text: error,
               footer: 'smd_getMyOrganization'
            })
            }
         },
         async setPaymentMethods(){
            let form = null
            //------
            let pullData = null
            let pushData = null
            let type = null
            try {
               pushData={
                  PK: '#SMARTDASH',
                  SK: "#"+this.organizationID,
               }
               pullData = await API.graphql({
                  query: smd_getRecordObj,
                  variables: pushData
               })
               pullData = pullData.data.smd_getRecordObj
               pullData = JSON.parse(pullData.data)
               console.log(pullData);
               type = this.organizationData.paymentMode.toLowerCase() 
               } catch (error) {
                  console.log(error);
               //popUp(error, 'cach', 'err')
               }
               //------
               setTimeout(() => {
               //console.clear()
               let authorization = null;
               this.methodPayment = this.publicOrgPay.paymentMode;
               form = document.getElementById('cardForm')
               if (type == 'production') {
                  authorization = pullData.clientsideToken.value
               } else {
                  authorization = pullData.sandboxClientsideToken.value;
               }
               braintree.client.create({ authorization: authorization }, 
               function (err, clientInstance) {
                  if (err) {
                     console.error(err);
                     return;
                  }
                  createHostedFields(clientInstance);
               });
               }, 500);
               function createHostedFields(clientInstance) {
               braintree.hostedFields.create({
                  client: clientInstance,
                  styles: {
                     'input': {
                     'font-size': '16px',
                     'font-family': 'courier, monospace',
                     'font-weight': 'lighter',
                     'color': '#555555'
                     },
                     ':focus': {
                     'color': 'black'
                     },
                     '.valid': {
                     'color': '#08a414f7'
                     }
                  },
                  fields: {
                     number: {
                     selector: '#card-number',
                     //placeholder: '4111 1111 1111 1111'
                     },
                     cvv: {
                     selector: '#cvv',
                     //placeholder: '123'
                     },
                     expirationDate: {
                     selector: '#expiration-date',
                     placeholder: 'MM/YYYY'
                     },
                     postalCode: {
                     selector: '#postal-code',
                     //placeholder: '11111'
                     }
                  }
               }, function (err, hostedFieldsInstance) {
                  if (err) {
                     console.error(err);
                     return;
                  }
                  var tokenize = function (event) {
                     event.preventDefault();
                     hostedFieldsInstance.tokenize(function (err, payload) {
                     if (err) {
                        console.log(err);
                        tokenQuote = JSON.stringify({token:null, processorResponse:err })
                        return;
                     }
                     tokenQuote = JSON.stringify({token:payload.nonce, processorResponse:payload })
                     hostedFieldsInstance.clear('number');
                     hostedFieldsInstance.clear('cvv');
                     hostedFieldsInstance.clear('expirationDate');
                     hostedFieldsInstance.clear('postal-cod');
                     //alert('Submit your nonce (' +  payload.nonce + ') to your server here!');
                     });
                  };
                  
                  form.addEventListener('submit', tokenize, false);
                  //form.on("submit", tokenize, false);
               });
               }
         },
         async token(){
            let pushData = null
            try {
               console.log(tokenQuote);
               if (JSON.parse(tokenQuote).token == null) {
                  return
               }
               loading('show')
               pushData = await API.graphql({
                  query : smd_savePaymentFormContact,
                  variables:{
                     orgPK: this.publicOrganization ,// data.PK,
                     paymentParameters: tokenQuote,
                     contactSK: this.attUser['custom:GSP1PK1']
                  }
               })
               
               pushData = pushData.data.smd_savePaymentFormContact
               console.log(pushData, tokenQuote);
               this.getLayout()
               loading('hidden')
            } catch (error) {
            loading('hidden')
               console.log(error);
               popUp(error, 'cach', 'err')
            }
         },
         async action(){
            setTimeout(() => {
               this.token()
            }, 1000);
         },
         //page
         setValue(data){
            let value = data
            try {
               //value = JSON.parse(value).value
            } catch (error) {
               
            }
            return value
         },
         async subscribe() {
            API.graphql({  query: onUpdateSmartRecord, variables: { PK: this.organizationID }  }).subscribe({
               next: (eventData) => {
                  try {
                     let pullData = eventData.value.data.onUpdateSmartRecord;
                     let subRecord =JSON.parse(pullData.data)
                     //Process subRecord
                     //for (const key in subRecord.attributes) {
                        //subRecord[key] = subRecord.attributes[key].attributeValue
                     //}
                     //subRecord = recordToDisplay(subRecord)
                     //-- Sub in table
                     let exist = false
                     console.log(subRecord);
                     if (subRecord.PK == this.organizationID  ) {
                        console.log('** NEW SUB: '+ subRecord.shortEntity ,subRecord);
                        for (let i = 0; i <  this.data.Tables.length; i++) {
                           for (let j = 0; j < this.data.Tables[i].data.length; j++) {
                              if (this.data.Tables[i].data[j].SK == subRecord.SK) {
                                 subRecord.subscribe = 'edit'
                                 exist = true
                                 this.data.Tables[i].data[j] = subRecord
                              }
                           }
                        }
                        if (exist == false) {
                           console.log(this.data.Tables[0]);
                           console.log(this.data.Tables[0].shortEntity == subRecord.shortEntity, this.data.Tables[0].shortEntity, subRecord.shortEntity);
                           if (this.data.Tables[0].shortEntity == subRecord.shortEntity) {
                              if(subRecord.GSP1PK1 == this.attUser['custom:GSP1PK1']){
                                 subRecord.subscribe = 'new'
                                 this.data.Tables[0].data.splice(0, 0, subRecord)
                              }
                           }
                        }
                     }else{
                        if (subRecord.PK == '#SMARTDASH' && this.userPermissions.includes('Superadmin')) {
                        //console.log('** NEW SUB ADMIN: '+ subRecord.shortEntity ,subRecord);
                        
                        }else{
                        //console.log('no son iguales')
                        }
                     }
                  } catch (error) {
                     console.log(error);
                  }
               }
            });
            API.graphql({  query: onUpdateAttributes  }).subscribe({
               next: (eventData) => {
                  try {
                     let pullData = eventData.value.data.onUpdateAttributes;
                     let subRecord =JSON.parse(pullData.data)
                     let exist = false
                     console.log(subRecord);
                     if (subRecord.PK == this.organizationID   ) {
                        console.log('** NEW SUB: '+ subRecord.shortEntity ,subRecord);
                        for (let i = 0; i <  this.data.Tables.length; i++) {
                           for (let j = 0; j < this.data.Tables[i].data.length; j++) {
                              if (this.data.Tables[i].data[j].SK == subRecord.SK) {
                                 subRecord.subscribe = 'edit'
                                 exist = true
                                 this.data.Tables[i].data[j] = subRecord
                              }
                           }
                        }
                        if (exist == false) {
                           for (let i = 0; i < this.data.Tables.length; i++) {
                              console.log(this.data.Tables[i]);
                              if (this.data.Tables[i].shortEntity == subRecord.shortEntity) {
                                 if(subRecord.GSP1PK1 == this.attUser['custom:GSP1PK1']){
                                    subRecord.subscribe = 'new'
                                    this.data.Tables[i].data.splice(0, 0, subRecord)
                                 }
                              }
                           }
                        }
                     }else{
                        if (subRecord.PK == '#SMARTDASH' && this.userPermissions.includes('Superadmin')) {
                        //console.log('** NEW SUB ADMIN: '+ subRecord.shortEntity ,subRecord);
                        
                        }else{
                        //console.log('no son iguales')
                        }
                     }
                  } catch (error) {
                     console.log(error);
                  }
               }
            });
            API.graphql({ query: onSetItemState }).subscribe({
            next: (eventData) => {
               let pullData = eventData.value.data.onSetItemState;
               let subRecord =JSON.parse(pullData.data)
               //Process subRecord
               //for (const key in subRecord.attributes) {
                  //subRecord[key] = subRecord.attributes[key].attributeValue
               //}
               //subRecord = recordToDisplay(subRecord)
               //-- Sub in table
               let exist = false
               console.log(subRecord);
               if (subRecord.PK == this.organizationID   ) {
                  console.log('** NEW SUB: '+ subRecord.shortEntity ,subRecord);
                  for (let i = 0; i <  this.data.Tables.length; i++) {
                     for (let j = 0; j < this.data.Tables[i].data.length; j++) {
                        if (this.data.Tables[i].data[j].SK == subRecord.SK) {
                           subRecord.subscribe = 'edit'
                           //exist = true
                           this.data.Tables[i].data= splice(j, 1)
                        }
                     }
                  }
               }else{
                  if (subRecord.PK == '#SMARTDASH' && this.userPermissions.includes('Superadmin')) {
                  //console.log('** NEW SUB ADMIN: '+ subRecord.shortEntity ,subRecord);
                  
                  }else{
                  //console.log('no son iguales')
                  }
               }
               setTimeout(() => { this.renderComponent = true }, 100);
            }
            });
            
         },
      },
      computed: {
         ...Vuex.mapState([
            "organizationID",
            "publicOrganization",
            "attUser",
            "publicOrganizationData",
            "organizationData",
            'user',
            "dataUser",
            "userPermissions",
            'publicOrgPay'
         ]),
      },
      watch: {
         
      },
   };

</script>